import { render, staticRenderFns } from "./TenantSelector.vue?vue&type=template&id=130b9bd2&scoped=true&"
import script from "./TenantSelector.vue?vue&type=script&lang=js&"
export * from "./TenantSelector.vue?vue&type=script&lang=js&"
import style0 from "./TenantSelector.vue?vue&type=style&index=0&id=130b9bd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130b9bd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VCardText,VIcon,VPagination,VTextField,VTooltip,VTreeview})
